import styled from 'styled-components';
import { rem } from 'polished';
import { CarOptionTemplate } from './CarOptionTemplate';

export const CarOptionStyled = styled(CarOptionTemplate)`
    border: 1px solid ${({ theme }) => theme.colors.grey25};
    cursor: pointer;
    margin: ${rem(8)} 0;
    background: none;
    width: 100%;
    text-align: left;
    padding: 0;

    .inner {
        height: 100%;
        border: 1px solid transparent;
        padding: ${rem(23)};
    }

    &:hover,
    &:focus-visible {
        border: 1px solid ${({ theme }) => theme.colors.primary};
        .inner {
            border: 1px solid ${({ theme }) => theme.colors.primary};
        }
    }

    &.isSelected {
        border-color: ${({ theme }) => theme.colors.primary};
        background: ${({ theme }) => theme.colors.primaryLight};
        .inner {
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }

    &.isSelected {
        .checkboxWrapper .checkbox-input + label {
            &::before {
                border: 1px solid ${({ theme }) => theme.colors.primary};
                background-color: ${({ theme }) => theme.colors.primary};
            }
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: ${rem(1)};
                left: ${rem(7)};
                width: ${rem(10)};
                height: ${rem(15)};
                border: solid ${({ theme }) => theme.colors.white};
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
            }
        }
    }

    .option-card {
        &__name {
            padding-left: ${rem(40)};
            position: relative;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            color: ${({ theme }) => theme.colors.black2};
            line-height: 1.43;

            .checkbox {
                position: absolute;
                left: ${rem(0)};
                top: ${rem(0)};
            }
        }

        &__add-priceWrapper {
            font-weight: normal;
        }

        &__imageWrapper {
            position: relative;
            margin-top: ${rem(20)};
            display: inline-block;
            width: 100%;

            .info {
                svg {
                    bottom: ${rem(13)};
                    right: ${rem(10)};
                }
            }

            svg {
                position: absolute;
                right: ${rem(8)};
                bottom: ${rem(11)};
                z-index: 2;
            }

            &.withoutOptionIcon {
                .optionIcon {
                    display: none;
                }
            }

            &.withOptionIcon {
                &::before {
                    content: '';
                    display: block;
                    width: ${rem(40)};
                    height: ${rem(40)};
                    position: absolute;
                    right: 0;
                    bottom: ${rem(3)};
                    background: ${({ theme }) => theme.colors.grey25};
                    z-index: 1;
                }
            }
            &:hover {
                opacity: 0.9;
            }
        }

        &__image {
            max-width: 100%;
            position: relative;
        }

        &__detailLink {
            margin-top: ${rem(20)};
            margin-bottom: 0;
            text-decoration: underline;
        }

        &__detailDescription {
            display: -webkit-box;
            -webkit-line-clamp: 6;
            -webkit-box-orient: vertical;
            overflow: hidden;

            ul {
                display: -webkit-box;
                -webkit-line-clamp: 6;
                -webkit-box-orient: vertical;
                overflow: hidden;
                padding-left: ${rem(20)};

                li {
                    margin-left: ${rem(5)};
                }
            }
        }
    }
`;
